import { useAuth0 } from '@auth0/auth0-react'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { QueryKeys } from '../../types'
import { getUserCases } from './case'
import { CaseResponse } from './types'
import { isCaseUnread } from '../../../../utils/caseMessages'

const useCaseQueryOptions = () => {
  const { getAccessTokenSilently } = useAuth0()
  return {
    queryKey: [QueryKeys.Cases, 'private'] as const,
    queryFn: async () => getUserCases({ accessToken: await getAccessTokenSilently() }),
  }
}

export const useGetUserCasesQuery = (): UseQueryResult<CaseResponse[], Error> => {
  return useQuery(useCaseQueryOptions())
}

export const useUnreadCaseMessagesCount = (): UseQueryResult<number, Error> => {
  return useQuery({
    ...useCaseQueryOptions(),
    select: (cases) => cases.filter(isCaseUnread).length,
  })
}
